'use client';

import { forwardRef, SelectHTMLAttributes } from 'react';
import { ChevronDownIcon } from 'lucide-react';

interface SelectFieldProps extends SelectHTMLAttributes<HTMLSelectElement> {
  hasError?: boolean;
  placeholder?: string;
  options: { value: string; label: string }[];
}

const SelectField = forwardRef<HTMLSelectElement, SelectFieldProps>(
  ({ hasError, placeholder, options, className = '', ...props }, ref) => {
    return (
      <div data-component-id="src/app/provider-profile-form/components/SelectField.tsx:15:6" data-component-path="src/app/provider-profile-form/components/SelectField.tsx" data-component-line="15" data-component-end-line="45" data-component-file="SelectField.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative">
        <select data-component-id="src/app/provider-profile-form/components/SelectField.tsx:16:8" data-component-path="src/app/provider-profile-form/components/SelectField.tsx" data-component-line="16" data-component-end-line="40" data-component-file="SelectField.tsx" data-component-name="select" data-component-content="%7B%22elementName%22%3A%22select%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
          ref={ref}
          className={`
            w-full h-10 pl-3 pr-8 rounded-lg border text-sm font-medium text-foreground bg-white appearance-none
            transition-all duration-150
            focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary
            disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-muted
            ${hasError
              ? 'border-destructive focus:ring-destructive/20 focus:border-destructive bg-destructive/5' :'border-input hover:border-primary/50'
            }
            ${className}
          `}
          {...props}
        >
          {placeholder && (
            <option data-component-id="src/app/provider-profile-form/components/SelectField.tsx:31:12" data-component-path="src/app/provider-profile-form/components/SelectField.tsx" data-component-line="31" data-component-end-line="33" data-component-file="SelectField.tsx" data-component-name="option" data-component-content="%7B%22elementName%22%3A%22option%22%2C%22value%22%3A%22%22%7D" value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((opt) => (
            <option data-component-id="src/app/provider-profile-form/components/SelectField.tsx:36:12" data-component-path="src/app/provider-profile-form/components/SelectField.tsx" data-component-line="36" data-component-end-line="38" data-component-file="SelectField.tsx" data-component-name="option" data-component-content="%7B%22elementName%22%3A%22option%22%7D" key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <ChevronDownIcon data-component-id="src/app/provider-profile-form/components/SelectField.tsx:41:8" data-component-path="src/app/provider-profile-form/components/SelectField.tsx" data-component-line="41" data-component-end-line="44" data-component-file="SelectField.tsx" data-component-name="ChevronDownIcon" data-component-content="%7B%22elementName%22%3A%22ChevronDownIcon%22%2C%22className%22%3A%22absolute%20right-2.5%20top-1%2F2%20-translate-y-1%2F2%20text-muted-foreground%20pointer-events-none%22%7D"
          size={14}
          className="absolute right-2.5 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
        />
      </div>
    );
  }
);

SelectField.displayName = 'SelectField';
export default SelectField;